import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { useTravelTranslation } from '../../app/TravelLocaleContext';

/** Native modal supplies inert background, focus containment and Escape dismissal. */
export default function JourneyFilterDialog({ enabled, open, onClose, title, children }) {
  const ref = useRef(null);
  const { t } = useTravelTranslation();
  useEffect(() => {
    if (!enabled || !open) return undefined;
    const previous = document.activeElement;
    const dialog = ref.current;
    dialog.showModal();
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      dialog.close();
      document.body.style.overflow = overflow;
      if (previous?.isConnected) previous.focus();
    };
  }, [enabled, open]);
  if (!enabled) return children;
  if (!open) return null;
  return createPortal(
    <dialog ref={ref} className="journey-filter-dialog" aria-labelledby="journey-filter-title"
      onCancel={(event) => { event.preventDefault(); onClose(); }}>
      <header>
        <h2 id="journey-filter-title">{title}</h2>
        <button type="button" onClick={onClose}>{t('travel.journeyDiscovery.close')}</button>
      </header>
      {children}
    </dialog>, document.body,
  );
}
